import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import AddOutlined from '@mui/icons-material/AddOutlined';
import { Button, SearchField } from '../../../../../components/ui';
import { UI_FIELD_TYPES } from '../../utils/fieldTypeAdapter';

export default function FormFieldsToolbar({
  viewMode,
  onViewModeChange,
  search,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  fieldCount,
  onAddField,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1.5,
        alignItems: 'center',
        mb: 2,
      }}
    >
      <SearchField
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Search fields"
        sx={{ minWidth: { xs: '100%', sm: 220 }, flex: { sm: 1 } }}
      />
      <Box component="select"
        value={typeFilter}
        onChange={(event) => onTypeFilterChange(event.target.value)}
        sx={{
          minHeight: 40,
          px: 1.5,
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <option value="">All types</option>
        {UI_FIELD_TYPES.map((type) => (
          <option key={type.value} value={type.value}>
            {type.label}
          </option>
        ))}
      </Box>
      <TypographyCount count={fieldCount} />
      <ToggleButtonGroup
        size="small"
        exclusive
        value={viewMode}
        onChange={(_, value) => value && onViewModeChange(value)}
      >
        <ToggleButton value="cards">Cards</ToggleButton>
        <ToggleButton value="table">Table</ToggleButton>
      </ToggleButtonGroup>
      <Button variant="primary" icon={<AddOutlined />} onClick={onAddField}>
        Add field
      </Button>
    </Box>
  );
}

function TypographyCount({ count }) {
  return (
    <Box sx={{ fontSize: 13, color: 'text.secondary', whiteSpace: 'nowrap' }}>
      {count} field{count === 1 ? '' : 's'}
    </Box>
  );
}
